<div class="layout-col full bg-background">
  <!-- Header Section -->

  <mat-toolbar elderTheme class="gap-md">
    <button mat-icon-button (click)="onClose($event)">
      <mat-icon>close</mat-icon>
    </button>
    <elder-header [header]="'operations.operation' | translate" [subheader]="'ID: ' + copy.action">
    </elder-header>
  </mat-toolbar>

  <app-instruction-browser
    class="flex"
    [operationSegmentSpec]="copy"
    (close)="onClose($event)"
    (save)="onSave($event)"
  >
  </app-instruction-browser>
</div>
